import Image from 'next/image'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'
import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'

interface CardEvaluasiKinerjaProps {}

export default function CardEvaluasiKinerja({}: CardEvaluasiKinerjaProps) {
  const { trackEvent } = useSKPPelaksanaanTrackEvent()
  const { periodYear } = usePeriodContext()

  return (
    <Card className="p-6">
      <div className="flex gap-6 items-center">
        <div className="flex-shrink-0">
          <Image
            alt=""
            src="/illustrations/img-document-stamp.png"
            width={84}
            height={84}
          />
        </div>
        <div className="flex-1 flex flex-col gap-1 justify-center items-start">
          <div className="flex flex-col items-start gap-2">
            <Text variant="subheading" color="subdued" className="!uppercase">
              Hasil Penilaian Kinerja Pegawai
            </Text>
            <Text variant="heading-lg">
              Predikat Kinerja Pegawai {periodYear}
            </Text>
          </div>
        </div>
        <div className="w-60">
          <Link
            href={`${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-evaluasi-kinerja-pegawai`}
            passHref
          >
            <Button
              size="lg"
              as="a"
              fullWidth
              onClick={() =>
                trackEvent({
                  activity_type: 'click_cek_dokumen_evaluasi',
                  screen_name: 'homepage_pengelolaan',
                })
              }
            >
              Cek
            </Button>
          </Link>
        </div>
      </div>
    </Card>
  )
}
